/**
 * qbrix-wheel.js — Wheel of Fortune popup
 * Requires: window.QbrixAssets (qbrix-assets-map snippet)
 *           window.QbrixWheelConfig (wheel-config snippet)
 */

// Правка 3: локальная функция wheelFillBrickRow (не копия fillBrickRow из homepage)
function wheelFillBrickRow(id) {
  var el = document.getElementById(id);
  if (!el) return;
  var PALETTE = [
    window.QbrixAssets['brick-retrowave-1-pink'],
    window.QbrixAssets['brick-retrowave-2-purple'],
    window.QbrixAssets['brick-retrowave-3-navy'],
    window.QbrixAssets['brick-retrowave-4-mint'],
    window.QbrixAssets['brick-retrowave-5-yellow'],
  ];
  var SIZE = 20;
  var count = Math.ceil(window.innerWidth / SIZE) + 2;
  el.innerHTML = '';
  for (var i = 0; i < count; i++) {
    var img = document.createElement('img');
    img.src = PALETTE[i % PALETTE.length];
    img.width = SIZE;
    img.height = SIZE;
    img.alt = '';
    img.style.cssText = 'flex-shrink:0;display:block;';
    el.appendChild(img);
  }
}

var currentRotation = 0;
var STORAGE_KEY = 'qbrix_wheel_shown';

// ---- Pixel waves state ----
function setWavesState(state) {
  document.querySelectorAll('.wave-bar').forEach(function(w) {
    w.classList.remove('idle', 'active');
    w.classList.add(state);
  });
}

// ---- SPIN — One-transition near-miss ----
//
// Geometry:
//   Arrow points up (0°). Wheel rotates clockwise.
//   Sector X is under the arrow when wheel has rotated (360 - centerX) degrees.
//
//   Sector 0 (DISKON 10%): center = 22.5° → under arrow at rotation = 337.5°
//   Sector 1 (TIDAK MENANG): center = 67.5° → under arrow at rotation = 292.5°
//   Boundary 0/1: at 45° → under arrow at rotation = 315°
//
//   We stop at 320° = just inside sector 0, near the boundary with sector 1.
//   This reads as "almost hit TIDAK MENANG but landed on DISKON 10%!" — max tension.
//
function spinWheel() {
  var btn = document.getElementById('wf-btn-spin');
  if (btn.disabled) return;
  btn.disabled = true;

  btn.classList.add('pressing');
  setTimeout(function() { btn.classList.remove('pressing'); }, 80);

  document.getElementById('wf-pointer').classList.add('pointer-spinning');
  setWavesState('active');

  var wheel = document.getElementById('wf-wheel');

  var FULL_SPINS       = 5;
  var NEAR_MISS_TARGET = 320;

  var finalAngle = currentRotation + (FULL_SPINS * 360) + NEAR_MISS_TARGET;

  wheel.style.transition = 'transform 5.5s cubic-bezier(0.15, 0.85, 0.3, 1)';
  wheel.style.transform  = 'rotate(' + finalAngle + 'deg)';
  currentRotation = finalAngle;

  setTimeout(function() {
    document.getElementById('wf-pointer').classList.remove('pointer-spinning');
    setWavesState('active');
    document.getElementById('crt-flash').classList.add('flash-active');
    showResult();
  }, 5700);
}

// ---- Confetti ----
function createConfetti() {
  var container = document.getElementById('wf-confetti-container');
  container.innerHTML = '';
  var colors = ['#E02F85', '#F8C100', '#B1D9C0', '#4B275E', '#FFFFFF'];
  for (var i = 0; i < 20; i++) {
    var div = document.createElement('div');
    div.className = 'wf-confetti-piece';
    div.style.position = 'absolute';
    div.style.borderRadius = '2px';
    var size = Math.random() > 0.5 ? '8px' : '6px';
    div.style.width  = size;
    div.style.height = size;
    div.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
    div.style.left             = (Math.random() * 100) + '%';
    div.style.top              = '-20px';
    div.style.animationDelay   = (Math.random() * 0.4) + 's';
    div.style.animationDuration = (1.8 + Math.random() * 1.4) + 's';
    container.appendChild(div);
  }
}

// ---- Show result screen ----
function showResult() {
  document.getElementById('wf-step-spin').style.display = 'none';
  var stepResult = document.getElementById('wf-step-result');
  stepResult.style.display = 'flex';
  stepResult.style.opacity = '0';
  stepResult.style.transform = 'translateY(16px)';

  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      stepResult.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      stepResult.style.opacity    = '1';
      stepResult.style.transform  = 'translateY(0)';
      createConfetti();
    });
  });
}

// ---- WA Input Masking ----
function wheelWaMask(input) {
  var v = input.value.replace(/\D/g, '');
  if (v.startsWith('0'))  v = v.slice(1);
  if (v.startsWith('62')) v = v.slice(2);
  v = v.slice(0, 13);

  var f = v;
  if (v.length > 3 && v.length <= 7) f = v.slice(0, 3) + ' ' + v.slice(3);
  if (v.length > 7)                   f = v.slice(0, 3) + ' ' + v.slice(3, 7) + ' ' + v.slice(7);

  input.value = f;

  if (v.length > 0) {
    document.getElementById('wf-wa-error').style.display = 'none';
  }
}

function showWheelSuccess() {
  var formArea = document.getElementById('wf-success-area');
  if (formArea) {
    formArea.style.display = 'flex';
  }
  // Hide the form elements
  var inputGroup = document.getElementById('wf-wa-form-group');
  if (inputGroup) {
    inputGroup.style.display = 'none';
  }
}

function klaimHadiah() {
  var raw = document.getElementById('wf-wa-input').value.replace(/\D/g, '');
  if (raw.length < 9) {
    var err = document.getElementById('wf-wa-error');
    err.style.display = 'block';
    var inputEl = document.getElementById('wf-wa-input');
    inputEl.style.animation = 'none';
    void inputEl.offsetWidth;
    inputEl.style.animation = 'wf-shake 0.4s ease';
    return;
  }
  document.getElementById('wf-wa-error').style.display = 'none';

  var userPhone      = '62' + raw;
  var businessNumber = window.QbrixWheelConfig.waNumber;
  var apiEndpoint    = window.QbrixWheelConfig.apiEndpoint;
  var wheelToken     = window.QbrixWheelConfig.wheelToken;

  // 1. Save to localStorage first (before any fetch)
  try {
    localStorage.setItem(STORAGE_KEY, '1');
    localStorage.setItem('qbrix_wheel_phone', userPhone);
    // qbrix_wheel_promo не пишем — пользователь получит QB-XXXX через WA
  } catch(e) { /* Safari private / quota exceeded — continue anyway */ }

  // 2. Fire-and-forget request to VPS (does not block UX)
  if (apiEndpoint && wheelToken) {
    fetch(apiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Wheel-Token': wheelToken
      },
      body: JSON.stringify({ phone: userPhone })
    }).catch(function() {
      // Silent fail — VPS unavailable but WA deeplink opens regardless
    });
  }

  // 3. Show success message (no WA redirect)
  showWheelSuccess();
  if (typeof qbxTrack === 'function') {
    qbxTrack('wheel_lead', { method: 'whatsapp' });
  }
}

// ---- Modal Controls ----
function showWheel() {
  var overlay = document.getElementById('wf-overlay');
  var modal   = document.getElementById('wf-modal');

  // Reset to step 1
  document.getElementById('wf-step-spin').style.display     = 'flex';
  document.getElementById('wf-step-result').style.display   = 'none';
  document.getElementById('wf-wheel').style.transition      = 'none';
  document.getElementById('wf-wheel').style.transform       = 'rotate(0deg)';
  document.getElementById('wf-pointer').classList.remove('pointer-spinning');
  document.getElementById('crt-flash').classList.remove('flash-active');
  document.getElementById('wf-confetti-container').innerHTML = '';
  document.getElementById('wf-wa-input').value              = '';
  document.getElementById('wf-wa-error').style.display      = 'none';
  var successArea = document.getElementById('wf-success-area');
  if (successArea) successArea.style.display = 'none';
  var formGroup = document.getElementById('wf-wa-form-group');
  if (formGroup) formGroup.style.display = '';

  var btn = document.getElementById('wf-btn-spin');
  btn.disabled = false;
  btn.classList.remove('pressing');
  currentRotation = 0;

  setWavesState('idle');

  overlay.style.display = 'flex';
  requestAnimationFrame(function() {
    overlay.style.opacity     = '1';
    modal.style.transform     = 'scale(1)';
    modal.style.opacity       = '1';
  });
}

function closeWheel() {
  var overlay = document.getElementById('wf-overlay');
  var modal   = document.getElementById('wf-modal');
  overlay.style.opacity = '0';
  modal.style.transform = 'scale(0.85)';
  modal.style.opacity   = '0';
  setTimeout(function() { overlay.style.display = 'none'; }, 350);
}

// ---- Правка 6: Debug API ----
window.QbrixWheel = {
  show: function() { showWheel(); },
  hide: function() { closeWheel(); },
  reset: function() {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem('qbrix_wheel_phone');
    localStorage.removeItem('qbrix_wheel_promo');
    showWheel();
  }
};

// ---- Init ----
document.addEventListener('DOMContentLoaded', function() {
  // Правка 7: ?wheel_reset=1 URL param — сбросить до проверки localStorage
  if (new URLSearchParams(window.location.search).get('wheel_reset') === '1') {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem('qbrix_wheel_phone');
    localStorage.removeItem('qbrix_wheel_promo');
  }

  // Build brick rows (Правка 2+3: через window.QbrixAssets, локальная функция)
  setTimeout(function() {
    wheelFillBrickRow('wf-bricks-top');
    wheelFillBrickRow('wf-bricks-bottom');
  }, 50);
  window.addEventListener('resize', function() {
    wheelFillBrickRow('wf-bricks-top');
    wheelFillBrickRow('wf-bricks-bottom');
  });

  var _shownAlready = false;
  try { _shownAlready = !!localStorage.getItem(STORAGE_KEY); } catch(e) {}
  if (_shownAlready) return;

  // Auto-trigger after 5 seconds
  setTimeout(function() {
    var _stillShown = false;
    try { _stillShown = !!localStorage.getItem(STORAGE_KEY); } catch(e) {}
    if (!_stillShown) {
      showWheel();
    }
  }, 5000);
});
